import { z } from 'zod';

// Base API error schema
export const ApiErrorSchema = z.object({
  errorMessage: z.string(),
  data: z
    .object({
      code: z.string().optional(),
    })
    .optional(),
  timestamp: z.number(),
});

// Type for API error
export type ApiError = z.infer<typeof ApiErrorSchema>;

// Function to validate API error
export function validateApiError(errorData: unknown): {
  isValid: boolean;
  apiError?: ApiError;
  isUnknownWorkspace: boolean;
} {
  try {
    const apiError = ApiErrorSchema.parse(errorData);

    return {
      isValid: true,
      apiError,
      isUnknownWorkspace: apiError.data?.code === 'unknown_workspace',
    };
  } catch {
    return {
      isValid: false,
      isUnknownWorkspace: false,
    };
  }
}
